import {
    FETCH_LOCATIONS_BEGIN,
    FETCH_LOCATIONS_SUCCESS,
    FETCH_LOCATIONS_ERROR,
    FETCH_LOCATIONS_RESET,
    DELETE_LOCATION_BEGIN,
    DELETE_LOCATION_ERROR,
    DELETE_LOCATION_RESET,
    DELETE_LOCATION_SUCCESS,
    SET_LOCATION_SEARCH_CRITERES,
    SET_LOCATION_SEARCH_RESULTS
} from '../actions/locationSearchActions'

const initialState = {
    locationFiches: [],
    criteres: null,
    fetchLocationFiches: {
        loading: false,
        error: false
    },
    deleteLocation: {
        deleting: false,
        deleted: false,
        error: false
    }
}

export default function locationSearchReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_LOCATIONS_BEGIN:
            return {
                ...state,
                fetchLocationFiches: {
                    loading: true,
                    error: false
                }
            }
        case FETCH_LOCATIONS_SUCCESS:
            return {
                ...state,
                locationFiches: action.payload.locationFiches,
                fetchLocationFiches: {
                    loading: false,
                    error: false
                }
            }
        case FETCH_LOCATIONS_ERROR:
            return {
                ...state,
                fetchLocationFiches: {
                    loading: false,
                    error: action.payload.error
                }
            }
        case FETCH_LOCATIONS_RESET:
            return {
                ...state,
                fetchLocationFiches: {
                    loading: false,
                    error: false
                }
            }
        // DELETE LOCATION
        case DELETE_LOCATION_BEGIN:
            return {
                ...state,
                deleteLocation: {
                    deleted: false,
                    deleting: true,
                    error: false,
                    ticket: action.payload.ticket
                }
            }
        case DELETE_LOCATION_ERROR:
            // Réponse d'une suppression abandonnée (RESET depuis — page
            // quittée en pleine suppression) : pas pour le modal ouvert.
            if (action.payload.ticket !== state.deleteLocation.ticket) return state
            return {
                ...state,
                deleteLocation: {
                    deleted: false,
                    deleting: false,
                    error: action.payload.error
                }
            }
        case DELETE_LOCATION_SUCCESS:
            if (action.payload.ticket !== state.deleteLocation.ticket)
                // Abandonnée (cf. ERROR) mais bien supprimée : seule sa
                // ligne quitte la liste — ni ✓ dans le modal d'une autre
                // fiche, ni résultats d'une recherche périmée.
                return {
                    ...state,
                    locationFiches: state.locationFiches.filter(
                        (f) => f.id !== action.payload.id
                    )
                }
            return {
                ...state,
                // Sans recherche relancée (fiche supprimée depuis la fiche,
                // résultats sans critères V2) : la liste perd juste la ligne.
                locationFiches: action.payload.relance
                    ? action.payload.locationFiches
                    : state.locationFiches.filter((f) => f.id !== action.payload.id),
                deleteLocation: {
                    deleted: true,
                    deleting: false,
                    error: false
                }
            }
        case DELETE_LOCATION_RESET:
            return {
                ...state,
                deleteLocation: {
                    deleted: false,
                    deleting: false,
                    error: false
                }
            }
        case SET_LOCATION_SEARCH_CRITERES:
            return {
                ...state,
                criteres: action.payload.criteres
            }
        case SET_LOCATION_SEARCH_RESULTS:
            return {
                ...state,
                locationFiches: action.payload.locationFiches
            }
        default:
            return state
    }
}